// Generated by ReScript, PLEASE EDIT WITH CARE


function fromString(userType) {
  switch (userType) {
    case "ADMIN_ACCESS" :
        return /* ADMIN_ACCESS */0;
    case "CREATE_ACCESS" :
        return /* CREATE_ACCESS */1;
    case "READ_ACCESS" :
        return /* READ_ACCESS */2;
    default:
      return /* NO_ACCESS */3;
  }
}

export {
  fromString ,
  
}
/* No side effect */
